import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearLoanData } from 'slices/loanFlowSlice'

const LoanFlowProtector = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    const allowedLoanFlowRegex = /^\/loans\/[^/]+\/(loan-offer|kfs|health-questionnaire|additional-info|sign|rssb-number|check-eligibility|request-loan)$/

    const isInLoanFlow = allowedLoanFlowRegex.test(location.pathname)

    if (!isInLoanFlow) {
      dispatch(clearLoanData())
      sessionStorage.removeItem('reduxState')
    }
  }, [location.pathname])

  return null
}

export default LoanFlowProtector
